import { render, staticRenderFns } from "./supplier-rfq.vue?vue&type=template&id=02087623&"
import script from "./supplier-rfq.vue?vue&type=script&lang=js&"
export * from "./supplier-rfq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports